module.exports = __webpack_public_path__ + "img/notes.730af4a5.svg";